/**
 * Component Registry for American Landmark Theme
 * 
 * Extends the base landing-page theme registry with American Landmark specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-landing-page/registry';
import { ThankYouHero } from './components/ThankYouHero';

/**
 * American Landmark specific component overrides.
 * These components have been customized for the American Landmark brand.
 */
const americanlandmarkOverrides: Partial<ComponentRegistry> = {
  ThankYouHero,
};

/**
 * Final merged registry for American Landmark properties.
 * Inherits all components from the landing-page theme, with American Landmark overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...americanlandmarkOverrides,
};

export default registry;
